import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CustomSelectStore {

}

export enum CustomSelectStoreKeys {

}
